module.exports = __webpack_public_path__ + "img/hat04_uv_umb_6a6.22fa1d60.svg";